<template>
    <div id="agentLogin">
        <div class="userFrom">
            <h2>
                <!-- <img src="./../../assets/yema-big.jpg" alt="" class="yema-img"> -->
                <div class="unserImg">
                    <img src="./../../assets/kairan-big.jpg" alt="" class="yema-img">
                </div>
                <div class="login">代理商登录</div>
            </h2>
            <div class="vant-hello">您好，</div>
             <div class="vant-hello1">欢迎来到流量数据</div>
            <form>
                <div class="formLine">
                    <input type="text" placeholder="请输入账号" v-model="loginForm.accountName">
                </div>
                <div class="formLine">
                    <input type="password" placeholder="请输入密码" v-model="loginForm.pwd">
                </div>
                <div class="formLine">
                    <mt-button v-if="loginBtn" type="primary" size="large" @click.prevent="agentLoginHandler">登录</mt-button> 
                </div>                           
            </form>
        </div>


        <!-- 修改密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel" 
            style="z-index: 2000; min-height: 55%; min-width: 80%;"
            v-show="showPasswordPanel"
            :style="{top:passwordPanelTop+'%'}">   

          <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
            <!-- 原密码输入框 -->
            <p>原密码：</p>
            <van-field type="password"   v-model="oldPassword" />
         
            <!-- 新密码输入框 -->
            <p>新密码：</p>
            <van-field  type="password"  v-model="newPassword" />

            <!-- 再次确认密码输入框 -->
            <p>再次确认：</p>
            <van-field type="password"   v-model="confirmPassword" />

            <div class="confirmChangePassword">
              <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToChangePassword()">确 定</van-button>
            </div>
            
        </div>
        <!-- 修改密码框 end  -->

    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            loginForm: {
                accountName: '',
                pwd: ''
            },

            loginBtn: true,

            //修改密码
              showPasswordPanel: false,

              oldPasswordKeyboard : false,
              newPasswordKeyboard : false,
              confirmPasswordKeyboard : false,

              oldPassword:'',
              newPassword:'',
              confirmPassword:'',
              passwordPanelTop: 50,
              //修改密码 end
        }        
    },
    methods: {
        agentLoginHandler(){
            var data = this.loginForm;
            wxRequest('xxtx/wx/sysUser/login', data, 'post').then(res => {
                if(res.data.code == 200){
                    var token = res.data.data.token;
                    localStorage.setItem('token', token);
                    localStorage.setItem('accountName', this.loginForm.accountName);
                    localStorage.setItem('nickName', res.data.data.nickName);
                    this.$store.state.token = token;
                    this.$router.push('/agent/home');
                }else if(res.data.code == 410){
                    this.$store.state.iccid = res.data.data.id;
                    localStorage.setItem('token', res.data.data.token);
                    this.$dialog.alert({message:res.data.message});
                    this.showPasswordPanel = true;
                }
                else{
                    this.$messagebox.alert(res.data.message)
                }
            })            
        },


        /***   修改密码     ***/

        cancelChangePassword(){
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
          this.passwordPanelTop = 50;
          this.showPasswordPanel = false;
        },

        sureToChangePassword(){
          if(this.newPassword!=this.confirmPassword){
            this.$dialog.alert({message:"两次输入的新密码不一致"});
            return ;
          }


          let data = {
            id: this.$store.state.iccid,
            oldPwd: this.oldPassword,
            newPwd: this.confirmPassword,

          }
          wxRequest('sysUser/updatePwd', data, 'post').then(res => {
            if(res.data.code == 200){
              Toast.success(res.data.message);
              this.cancelChangePassword();
            }else{
              this.$dialog.alert({message:res.data.message})
            }
          });
        },
        
        /***   修改密码  end   ***/



        //判断是否微信登陆
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        }
    },
    created(){
        
        // if (this.isWeiXin()) {
        //     let url = window.location.href;
        //     if(url.indexOf('wx.ischenxin.com')<0){
        //         this.loginBtn = false;
        //        this.$messagebox.alert('此域名登录权限受限');
        //     }
        // } 

    }
}
</script>



<style lang="less" scoped>
#agentLogin{
    height:100%;
    background: #F5F5F5;
    h2 {
        background: #1677FE;
        text-align: center;
         padding-top:41px;
        .unserImg{
            width:76px;
            height:76px;
            border-radius:100%;
            margin:0 auto;
            background:#fff;
            img{
                width:100%;
                height:100%;
                border-radius:100%;
            }
        }
        .login{
            font-size:28px;
            color:#fff;
            padding-top:16px;
            padding-bottom:26px;
        }
    }
    .vant-hello{
        color: #1677FE;
        font-size:26px;
        padding-top:36px;
        padding-bottom:16px;
        text-align: center;
    }
     .vant-hello1{
         color:#999;
         font-size:16px;
         text-align: center;
     }
     form{
         margin-top:64px;
         .formLine{
             text-align: center; 
             input{
                border-radius:24px;
                height:48px;
                width:276px;
                margin:0 auto 20px auto;
                border:1px solid #DDE6EF;
             }
             button{
                border-radius:24px;
                font-size:14px;
                height:48px;
                width:276px;
                margin:29px auto 0px auto;
             }
         }
     }
}
.changePasswordPanel{
  padding: 10px;

  .icon-cross{
    position: absolute; 
    right: 10px;
    font-size: 16px;
  }

  p{
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword{
      display:flex;
      justify-content: flex-end;
      margin-top: 20px;

      .confirmChangePasswordBtn{
          width: 80px;
          margin: 0 15px;
      }
  }

}
</style>